import React from 'react';
import {connect} from 'react-redux';

@connect(
	(state) => {
		return {
			windows: state.modals
		};
	})
export default class ModalWindowContainer extends React.Component {


	render() {
		return <span>
					{this.props.windows.map(item => {return <span key={item.id}>{item.modal}</span>})}
			   </span>
	}
};


// WEBPACK FOOTER //
// ./src/reactis/reactis-modal/src/ModalWindowContainer.js